// frontend/src/api/subscription.js
// Role: API integration functions for subscription management

import axios from 'axios';

const API_BASE_URL = 'https://addfly.me';
// const API_BASE_URL = 'http://localhost:8000';


export const subscriptionAPI = {
  /**
   * Subscribe email to daily news
   * @param {string} email - Email address to subscribe
   * @returns {Promise<{success: boolean, message: string}>}
   */
  subscribe: async (email) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/subscribe`, {
        email: email.trim()
      });
      
      return {
        success: true,
        message: response.data.message || 'Successfully subscribed!'
      };
      
    } catch (error) {
      console.error('Subscription error:', error);
      
      if (error.response) {
        // Server responded with error status
        return {
          success: false,
          message: error.response.data.detail || 'Subscription failed. Please try again.'
        };
      } else if (error.request) {
        // Network error
        return {
          success: false,
          message: 'Network error. Please check your connection and try again.'
        };
      } else {
        // Other error
        return {
          success: false,
          message: 'An unexpected error occurred. Please try again.'
        };
      }
    }
  },

  /**
   * Unsubscribe email from daily news
   * @param {string} email - Email address to unsubscribe
   * @returns {Promise<{success: boolean, message: string}>}
   */
  unsubscribe: async (email) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/unsubscribe`, {
        email: email.trim()
      });
      
      return {
        success: true,
        message: response.data.message || 'Successfully unsubscribed!'
      };
      
    } catch (error) {
      console.error('Unsubscribe error:', error);
      
      if (error.response) {
        // Server responded with error status
        return {
          success: false,
          message: error.response.data.detail || 'Unsubscribe failed. Please try again.'
        };
      } else if (error.request) {
        // Network error
        return {
          success: false,
          message: 'Network error. Please check your connection and try again.'
        };
      } else {
        // Other error
        return {
          success: false,
          message: 'An unexpected error occurred. Please try again.'
        };
      }
    }
  }
};

export default subscriptionAPI;
